import { useEffect, useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery, useQueryClient } from 'react-query'

import { getMerchantHistories } from 'api/merchanthistories'
import { useHistoryStore } from 'store/merchantHistories'
import { MerchantHistoriesFetchParamsTypes } from 'types/merchantHistories'

import { DATASTATUS } from 'constants/status'

export const useMemberHistory = () => {
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')
  const defaultParams = { traderId: memberTraderId }

  const historyModStatus = useHistoryStore((state) => state.historyModStatus)
  const historyModStatusSet = useHistoryStore(
    (state) => state.historyModStatusSet
  )
  const historyModErrors = useHistoryStore((state) => state.historyModStatus)
  const historyModErrorsSet = useHistoryStore(
    (state) => state.historyModErrorsSet
  )
  const history = useHistoryStore((state) => state.histories)
  const historySet = useHistoryStore((state) => state.historySet)
  const [historyFilterParams, historyFilterParamsSet] =
    useState<MerchantHistoriesFetchParamsTypes>(defaultParams)
  const [isHistoryFiltered, isHistoryFilteredSet] = useState<boolean>(false)

  const queryClient = useQueryClient()
  const {
    data: dataHistory,
    isLoading: isLoadingHistory,
    isError: isErrorHistory,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useHistory', historyFilterParams],
    queryFn: async () => {
      try {
        historyModStatusSet('loading')
        const response = await getMerchantHistories(historyFilterParams)
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        historyModStatusSet('success')
        return response.data
      } catch (e) {
        historyModStatusSet('fail')
        historyModErrorsSet(JSON.stringify(e))
      }
    },
  })

  const handleFilter = useCallback(
    async (filterParams: MerchantHistoriesFetchParamsTypes) => {
      historyFilterParamsSet(filterParams)
      isHistoryFilteredSet(true)
    },
    [historyFilterParamsSet, isHistoryFilteredSet]
  )

  const handleUnfilter = useCallback(() => {
    const test = { traderId: memberTraderId }
    historyFilterParamsSet(test)
    isHistoryFilteredSet(false)
  }, [historyFilterParamsSet, isHistoryFilteredSet])

  useEffect(() => {
    if (dataHistory) historySet(dataHistory)
  }, [dataHistory, historySet])

  return {
    memberHandleHistoryFilter: handleFilter,
    memberHandleHistoryUnfilter: handleUnfilter,
    memberHistoryFilterParams: historyFilterParams,
    memberHistory: history,
    memberHistoryModStatus: historyModStatus,
  }
}
